import { o as u } from "./query-assigned-elements.57643bdd.js";
function s(e, l) {
  return u({ descriptor: (n) => {
    const i = { get() {
      var o, r;
      return (r = (o = this.renderRoot) === null || o === void 0 ? void 0 : o.querySelector(e)) !== null && r !== void 0 ? r : null;
    }, enumerable: !0, configurable: !0 };
    if (l) {
      const o = typeof n == "symbol" ? Symbol() : "__" + n;
      i.get = function() {
        var r, t;
        return this[o] === void 0 && (this[o] = (t = (r = this.renderRoot) === null || r === void 0 ? void 0 : r.querySelector(e)) !== null && t !== void 0 ? t : null), this[o];
      };
    }
    return i;
  } });
}
export {
  s as i
};
